// extracted by mini-css-extract-plugin
export default {"modalWrap":"index_modalWrap_JXEf2","showMask":"index_showMask_Mnf-t"};